<ng-container [formGroup]="formularioInfoBasica">
  <div class="c-field c-field--checkbox">
    <label for="periodoInicial" class="u-bold f-14">Período de pago</label>
    <div class="">
      <div class="row">
        <div class="c-field_cont c-field_cont--right col-xs-12 col-md-6 col-lg-6">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="periodoInicioPicker"
              placeholder="Período Inicial"
              formControlName="periodoInicial"
              [min]="minFecha"
              [max]="maxPeriodoInicial"
            />
            <mat-datepicker-toggle matSuffix [for]="periodoInicioPicker"></mat-datepicker-toggle>
            <mat-datepicker
              #periodoInicioPicker
              startView="multi-year"
              (yearSelected)="manejarAnioSeleccionado('periodoInicial', $event)"
              (monthSelected)="manejarMesSeleccionado('periodoInicial', $event)"
            ></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="c-field_cont c-field_cont--right col-xs-12 col-md-6 col-lg-6">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="periodoFinPicker"
              placeholder="Período Final"
              formControlName="periodoFinal"
              [min]="minFechaFin"
              [max]="maxFechaFin"
            />
            <mat-datepicker-toggle matSuffix [for]="periodoFinPicker"></mat-datepicker-toggle>
            <mat-datepicker
              #periodoFinPicker
              startView="multi-year"
              (yearSelected)="manejarAnioSeleccionado('periodoFinal', $event)"
              (monthSelected)="manejarMesSeleccionado('periodoFinal', $event, true)"
            ></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-container>